import React from "react";
import RouteCategoryNote from "common/RouteCategoryNote";
import RouteListRenderer from "common/RouteListRenderer";

const PAGE_NAME = "General Private Buses (Kolkata and Howrah)";

const GeneralPrivateBusesKolkataHowrah = () => {
  document.title = `${PAGE_NAME} - Banglar Transit`;

  return (
    <main>
      <RouteListRenderer busRouteCategory={PAGE_NAME}>
        <p className="my-4">
          Here we list the usual buses which are visible in and around Kolkata,
          Howrah, North and South and 24 Parganas. These buses are as old as
          1928 and provide dedicated services to and from most localities. While
          most of the buses are blue-yellow in colour (with exceptions like
          blue-white), the minibuses are coloured in maroon-yellow scheme.
        </p>

        <RouteCategoryNote pageName={PAGE_NAME} />
      </RouteListRenderer>
    </main>
  );
};

export default GeneralPrivateBusesKolkataHowrah;
